module.exports = __webpack_public_path__ + "static/media/email.4b670a51.svg";